/**
 * FILE: src/blueprint/components/report/IndexCard.jsx
 */

function asString(value) {
  return typeof value === 'string' ? value : '';
}

export default function IndexCard({ icon = '', title = '', body = '', className = '' }) {
  const resolvedIcon = asString(icon).trim();
  const resolvedTitle = asString(title).trim();
  const resolvedBody = asString(body).trim();

  if (!resolvedTitle && !resolvedBody) {
    return null;
  }

  const cardClassName = ['dv-indexcard', className].filter(Boolean).join(' ');

  return (
    <div className={cardClassName}>
      {resolvedIcon ? (
        <div className="dv-indexcard__icon" aria-hidden="true">
          {resolvedIcon}
        </div>
      ) : null}

      <div className="dv-indexcard__content">
        {resolvedTitle ? <h3 className="dv-indexcard__title">{resolvedTitle}</h3> : null}
        {resolvedBody ? <p className="dv-indexcard__body">{resolvedBody}</p> : null}
      </div>
    </div>
  );
}
